export default "__VITE_ASSET__fyMoAz_Q__"